module.exports = __webpack_public_path__ + "img/affiche-luneville.40cf164.jpg";